"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeDeliveryType = exports.DeliveryOption = exports.DeliveryStatus = exports.DeliveryUserType = void 0;
var DeliveryUserType;
(function (DeliveryUserType) {
    DeliveryUserType["Carrier"] = "Carrier";
    DeliveryUserType["Client"] = "Client";
})(DeliveryUserType || (exports.DeliveryUserType = DeliveryUserType = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["ClientAccepted"] = "Accepted";
    DeliveryStatus["ClientRejected"] = "Rejected";
    DeliveryStatus["CarrierPickup"] = "CarrierPickup";
    DeliveryStatus["OrderNotDelivered"] = "OrderNotDelivered";
    DeliveryStatus["CantLocateClientLocation"] = "CantLocateClientLocation";
    DeliveryStatus["Other"] = "Other";
    DeliveryStatus["Pending"] = "Pending";
    DeliveryStatus["InTransit"] = "InTransit";
    DeliveryStatus["Delivered"] = "Delivered";
    DeliveryStatus["Cancelled"] = "Cancelled";
})(DeliveryStatus || (exports.DeliveryStatus = DeliveryStatus = {}));
var DeliveryOption;
(function (DeliveryOption) {
    DeliveryOption["PickUp"] = "PickerUP";
    DeliveryOption["HomeDelivery"] = "HomeDelivery";
    DeliveryOption["PickUpBySomeOne"] = "PickUpBySomeOne";
})(DeliveryOption || (exports.DeliveryOption = DeliveryOption = {}));
var HomeDeliveryType;
(function (HomeDeliveryType) {
    HomeDeliveryType["Oneway"] = "oneWay";
    HomeDeliveryType["DoubleWay"] = "DoubleWay";
})(HomeDeliveryType || (exports.HomeDeliveryType = HomeDeliveryType = {}));
//# sourceMappingURL=delivery.js.map